export const getBlobUrl = blob => {
  if (blob) {
    return window.URL.createObjectURL(blob)
  }
}
